<template>
<div class="widget-container" style="max-width: 1000px;">
	<widget>
		<h2>Project #{{ $store.project.job_num }}: {{ $store.project.job_name }}<br>
			<small>Change Order #CO-{{ $store.project.job_num }}-{{ changeOrder.quote_num }}</small>
		</h2>

		<div>
			<h5>Work Requested</h5>
			<div v-html="changeOrder.description"></div>
		</div>
	</widget>

	<div class="action-buttons-container d-flex justify-content-between flex-wrap mb-2">
		<div></div>
		<div>
			<span v-if="readonly" class="text-muted">This change order has a status that makes it readonly</span>
			<button type="button" class="btn btn-success" :disabled="readonly" v-on:click="addNewEntry">
				<i class="fa fa-plus"></i>
				Work Completed
			</button>
		</div>

	</div>

	<work-completed-entry v-for="(entry,index) in worksheets" 
		:key="'id' in entry ? entry.id : 'new'+index"
		:entry="entry"
		:readonly="readonly"
		:parent-id="changeOrder.id"
		parent-id-key="change_quote_id"
		:parts-fields="materialsUsedFields"
		:equipment-used-fields="equipmentUsedFields"
		:equipment-list="$store.equipments"
		:trigger-edit-mode="!('id' in entry)"
		:disable-assets="true"
		worksheet-api-resource="ChangeWorksheet"
		v-on:entryDeleted="fetchWorksheets"
		v-on:removeEntry="removeEntry(index)"
		v-on:entrySaved="fetchWorksheets">
	</work-completed-entry>

	<widget class="form">

		<div v-if="!changeOrderIsFieldEditable"
			class="alert alert-warning"
			style="margin-left: -15px;margin-right: -15px;margin-top: -15px;">

			This change order is in {{ changeOrder.quote_status }} status, is read-only now, and cannot be reverted back to a previous status from here.
			<template v-if="canRevertStatusFromDetails">
				The status can only be reverted from the <a href="#" v-on:click.prevent="$emit('activateSection', 'Details')">Details</a> or <a href="#" v-on:click.prevent="$emit('activateSection', 'Delivery')">Delivery</a> sections.
			</template>
			<template v-else>To revert the status you need write permissions</template>
		</div>

		<template v-if="classifiedDetailedClaims.length > 0">
			<h4>Labour Summary</h4>
			<table-list record-name="Time Log Claim"
				:fields="[
					{label: 'Classification',key: 'title'},
					{label: 'Type',key: 'timeType', align:'left'},
					{label: 'Total Time Claimed',key: 'totalTimeClaimed', align:'right'},
					
				]"
				:records="classifiedDetailedClaims">
			</table-list>
		</template>

		<form-group label="Total Hours for Sign-off"
			col-class="col-md-2 col-sm-3">

			<div class="row">
				<div class="col-auto">
					<field label="Reg"
						col-class="col-auto"
						:params="{type:'number',step:0.25}"
						:readonly="readonly"
						v-model="changeOrderPayload.summary_total_hours"
						v-on:change="saveSummaryHours">
					</field>
				</div>
				<div class="col-auto">
					<field label="OT"
						col-class="col-auto"
						:params="{type:'number',step:0.25}"
						:readonly="readonly"
						v-model="changeOrderPayload.summary_total_hours_ot"
						v-on:change="saveSummaryHours">
					</field>
				</div>
			</div>

			<!--
			<p class="mt-2">
				Total Calculated Time: <strong>{{ totalCalculatedHours }}</strong>
				<span class='text-muted'> (Calculated using detailed claims on closed time logs)</span>
			</p>
			-->

		</form-group>

		<form-group label="WO Summary" col-class="col-md-2 col-sm-3">
			<button class="btn btn-light" type="button" v-on:click="openWOSummary(true)">
				<i class="fa fa-list-alt"></i>
				View WO Summary
				<span> & Capture Signature</span>
			</button>
		</form-group>

		<wo-summary
			:visible="WOSummaryVisible"
			:change-order="changeOrder"
			:work-completed-entries="worksheets"
			:hide-sig="!WOSummaryShowSig"
			v-on:closeModal="WOSummaryVisible = false">		
		</wo-summary>

		<field 
			label="Status" 
			col-class="col-md-2 col-sm-3" 
			:params="{type:changeOrderIsFieldEditable ? 'select' : 'text',options: changeOrderStatusOptions('field')}" 
			v-model="changeOrderPayload.quote_status" 
			:readonly="!changeOrderIsFieldEditable"
			:invalid="$store.errorList.quote_status"
			v-on:change="statusChanged">
		</field>

		<field v-if="changeOrderStatusCompleted"
			label="Date Completed" 
			col-class="col-md-2 col-sm-3" 
			:params="{type:'date'}" 
			v-model="changeOrderPayload.completed" 
			:readonly="!changeOrderIsFieldEditable"
			:invalid="$store.errorList.completed"
			v-on:change="dateCompletedChange">
		</field>

	</widget>

</div>
</template>
<script type="text/javascript">
import Widget from "@/components/Widget"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import WorkCompletedEntry from "@/components/super_components/WorkCompletedEntry"
import WoSummary from "@/components/super_components/WoSummary"
import TableList from "@/components/TableList"

export default {
	name: "ProjectChangeOrderWorksheets",
	components: {
		Widget,
		Field,
		WorkCompletedEntry,
		WoSummary,
		FormGroup,
		TableList
	},
	props: ["changeOrder"],
	data() {
		return {
			changeOrderPayload: {},
			worksheets: [],
			equipmentUsedFields: [
				{label:'Equipment Type',key:'equipmentType'},
				{label:'Equipment Description',key:'description'},
				{label:'Hrs',key:'hrs',align:'right'}
			],
			materialsUsedFields: [
				{label: "Part Description",key:"description"},
				{label: "Part #",key:"part_number"},
				{label: "Qty",key:"qty",align:"right"},
				{label: "",key:"material_unit_type"}
			],
			detailedClaims: [],
			WOSummaryVisible: false,
			WOSummaryShowSig: true,
			WoSummaryWorkToDoSummary: false,
			changeOrderStatusCompleted: false
		}
	},
	watch: {
		changeOrder() {
			this.setChangeOrderPayload()

			if ("id" in this.changeOrder) {
				this.fetchTimeLogClaims()
				this.fetchWorksheets()
			}
		}
	},
	computed: {
		changeOrderIsFieldEditable() {
			let status = this.$store.changeOrderStatuses.find(status => status.label == this.changeOrder.quote_status)

			if (status && status.type == 'office')
				return false

			return true
		},
		readonly() {
			if (this.hasModulePermWrite("Projects") && this.changeOrder.quote_status == 'Complete')
				return false

			if (this.changeOrder.quote_status == 'Complete')
				return true

			if (!this.changeOrderIsFieldEditable)
				return true

			if (this.changeOrder.is_finalized == 1)
				return true

			if (this.getUserRoleType() == 'Basic' && !this.$store.userDetails.JobPersonnelRole.find(role => role.job_id == this.$store.project.id))
				return true

			return false
		},
		canRevertStatusFromDetails() {
			if (this.getUserRoleType() == 'Admin' || this.hasModulePermWrite('Projects'))
				return true

			return this.hasRoleBasedPermission('project', this.$store.project.id, 'write_perms')
		},
		totalCalculatedHours() {
			return 0
		},
		classifiedDetailedClaims() {
			let classifications = []

			this.detailedClaims.forEach(claim => {
				let classification = false
					
				if ("TimeLog" in claim && claim.TimeLog) {

					try {
						classification = JSON.parse(claim.TimeLog.classification_json)
					}
					catch (e) {}

					if (classification && "id" in classification) {
						if (claim.regular_hours > 0) {
							let foundIndex = classifications.findIndex(cl => cl.id == classification.id && cl.timeType == 'Reg')

							let time = +claim.regular_hours

							if (foundIndex >= 0) {
								classifications[foundIndex].totalTimeClaimedRaw += time
								classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)
							}
							else {
								classifications.push({
									id: classification.id,
									title: classification.title,
									timeType: "Reg",
									totalTimeClaimedRaw: time,
									totalTimeClaimed: time.toFixed(2)
								})
							}
						}

						let otKeys = ["overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]

						otKeys.forEach(key => {
							if (claim[key] > 0) {

								let time = +claim[key]

								let foundIndex = classifications.findIndex(cl => cl.id == classification.id && cl.timeType == 'OT')

								if (foundIndex >= 0) {
									classifications[foundIndex].totalTimeClaimedRaw += +claim[key]
									classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)	
								}
								else {
									classifications.push({
										id: classification.id,
										title: classification.title,
										timeType: "OT",
										totalTimeClaimedRaw: time,
										totalTimeClaimed: time.toFixed(2)
									})
								}
							}
						})
					}
					else {
						if (claim.regular_hours > 0) {
							let foundIndex = classifications.findIndex(cl => cl.id == 0 && cl.timeType == 'Reg')

							let time = +claim.regular_hours

							if (foundIndex >= 0) {
								classifications[foundIndex].totalTimeClaimedRaw += time
								classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)
							}
							else {
								classifications.push({
									id: 0,
									title: "Unclassified",
									timeType: "Reg",
									totalTimeClaimedRaw: time,
									totalTimeClaimed: time.toFixed(2)
								})
							}
						}

						let otKeys = ["overtime_hours_15x","overtime_hours_2x","overtime_hours_25x"]

						otKeys.forEach(key => {
							if (claim[key] > 0) {

								let time = +claim[key]

								let foundIndex = classifications.findIndex(cl => cl.id == 0 && cl.timeType == 'OT')

								if (foundIndex >= 0) {
									classifications[foundIndex].totalTimeClaimedRaw += +claim[key]
									classifications[foundIndex].totalTimeClaimed = classifications[foundIndex].totalTimeClaimedRaw.toFixed(2)	
								}
								else {
									classifications.push({
										id: 0,
										title: "Unclassified",
										timeType: "OT",
										totalTimeClaimedRaw: time,
										totalTimeClaimed: time.toFixed(2)
									})
								}
							}
						})
					}
				}
			})

			return classifications
		}
	},
	methods: {
		setChangeOrderPayload() {
			let vm = this
			let fields = ["quote_status","summary_total_hours","summary_total_hours_ot","completed"]

			fields.forEach(field => {
				if (field in vm.changeOrder)
					vm.changeOrderPayload[field] = vm.changeOrder[field]
			})

			this.setChangeOrderCompletedStatusValue()
		},
		addNewEntry() {
			this.worksheets.push({
				work_completed_description: "",
				change_quote_id: this.changeOrder.id
			})

			this.$nextTick(() => {
				window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
			})
		},
		removeEntry(index) {
			if (index == 0) {
				this.alertFail("Can't delete an entry if its the only one.")
			}
			else
				this.worksheets.splice(index,1)
		},
		openWOSummary(show_sig) {
			this.WOSummaryVisible = true
			this.WOSummaryShowSig = show_sig
		},
		statusChanged(status) {
			let vm = this

			this.$nextTick(() => {
				vm.setChangeOrderCompletedStatusValue()

				let payload = {
					id: vm.changeOrder.id,
					quote_status: status
				}

				if (!vm.changeOrderStatusCompleted)
					payload.completed = null
				else if (!vm.changeOrderPayload.completed) {
					vm.changeOrderPayload.completed = vm.moment().format("YYYY-MM-DD")
					payload.completed = vm.changeOrderPayload.completed
				}

				vm.postData("JobChangeOrder/save",payload,true)
					.then(response => {
						if (response.success) {
							vm.alertSaved("Status updated")
							vm.$emit("changeOrderChanged")
						}
					})

			})
		},
		setChangeOrderCompletedStatusValue() {
			let completedStatuses = ["Complete","Complete, Approved","Complete, Pending Approval"]

			this.changeOrderStatusCompleted = completedStatuses.indexOf(this.changeOrderPayload.quote_status) >= 0
		},
		dateCompletedChange(value) {
			let vm = this

			this.postData("JobChangeOrder/save",{id: this.changeOrder.id,
				completed: value},true).then(response => {
					vm.alertSaved("Date completed updated")
				})
		},
		saveSummaryHours() {
			let vm = this

			this.$nextTick(() => {
				let payload = {
					id: vm.changeOrder.id,
					summary_total_hours: vm.changeOrderPayload.summary_total_hours,
					summary_total_hours_ot: vm.changeOrderPayload.summary_total_hours_ot
				}

				vm.postData("JobChangeOrder/save",payload).then(response => {
					vm.$emit("changeOrderChanged")
				})
			})
		},
		fetchWorksheets() {
			let vm = this

			let params = {
				filters: [
					["change_quote_id",this.changeOrder.id]
				]
			}

			this.spinner(true)

			this.getJSON("ChangeWorksheet/get",params).then(response => {
				vm.spinner(false)

				if (response.success) {
					vm.worksheets = response.data
				}
			})
		},
		fetchTimeLogClaims() {
			let vm = this

			let params = {
				filters: [
					["change_quote_id",this.changeOrder.id]
				],
				include: [
					"TimeLog"
				]
			}

			this.getJSON("TimeLogDetailedClaim/get",params).then(response => {
				if (response.success)
					vm.detailedClaims = response.data
			})
		}
	},
	created() {
		if (this.changeOrder && "id" in this.changeOrder) {
			this.fetchWorksheets()
			this.fetchTimeLogClaims()
		}
		this.setChangeOrderPayload()
		this.fetchChangeOrderStatuses()
	}
}
</script>

<style type="text/css" scoped>
	@media (max-width: 550px) {
		.action-buttons-container {
			margin-right: -15px;
			margin-left: -15px;
		}
	}
</style>